import React, { useState } from 'react';
import styled from 'styled-components';
import Logo from './Logo';

interface TeamLogoProps {
  team: string;
  width?: string;
  height?: string;
}

const PlaceholderLogo = styled.div<{ width?: string; height?: string }>`
  width: ${props => props.width || '60px'};
  height: ${props => props.height || '60px'};
  background-color: #f5f5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--gray);
`;

const StyledImage = styled.img<{ width?: string; height?: string }>`
  width: ${props => props.width || '60px'};
  height: ${props => props.height || '60px'};
  object-fit: contain;
`;

const TeamLogo: React.FC<TeamLogoProps> = ({ team, width, height }) => {
  const [imageError, setImageError] = useState(false);

  if (team === 'Tigers') {
    return <Logo width={width} height={height} />;
  }

  // Remove numbers and spaces from the end of the team name
  const baseTeamName = team.replace(/[\d\s]+$/, '');
  const logoPath = `/images/teamLogos/${baseTeamName.replace(/\s+/g, '-')}.png`;

  if (!imageError) {
    return (
      <StyledImage
        src={logoPath}
        alt={`${team} Logo`}
        width={width}
        height={height}
        onError={() => setImageError(true)}
      />
    );
  }

  return (
    <PlaceholderLogo width={width} height={height}>
      {team.charAt(0)}
    </PlaceholderLogo>
  );
};

export default TeamLogo; 